/**
 * Centralized business / brand configuration for 4 Seasons Painting.
 * All hard-coded brand details should pull from here.
 */

export const siteConfig = {
  name: "4 Seasons Painting",
  shortName: "4 Seasons Painting",
  legalName: "4 Seasons Painting",
  owner: "Alvaro Campos Chacon",
  tagline: "Interior & Exterior Painting Across the Phoenix Valley",
  description:
    "Family-run painting contractor in Phoenix, AZ serving homes and businesses across the Valley. Interior and exterior painting, power washing, sun screens, rain gutter installation, and pergolas — open 24 hours a day, 7 days a week.",

  domain: "4-seasons-painting.com",
  url: "https://4-seasons-painting.com",

  phone: "(480) 758-9380",
  phoneHref: "tel:+14807589380",

  secondaryPhone: "(602) 617-4446",
  secondaryPhoneHref: "tel:+16026174446",

  email: "Campos2180@gmail.com",
  emailHref: "mailto:Campos2180@gmail.com",

  address: {
    street: "6933 West Roosevelt Street",
    city: "Phoenix",
    state: "AZ",
    stateFull: "Arizona",
    postalCode: "85043",
    country: "US",
    region: "Maricopa County",
    // Phrased adjectivally — rendered as "a {serviceRadius} radius".
    serviceRadius: "60-mile",
    full: "6933 West Roosevelt Street, Phoenix, AZ 85043",
  },

  hours: {
    summary: "Open 24/7 · Every Day",
    days: "Monday – Sunday",
    time: "24 hours a day",
  },

  logo: "/4-seasons-painting-logo.png",
  ogImage: "/4-seasons-painting-logo.png",
  favicon: "/4-seasons-painting-logo.png",

  social: {
    instagram: null,
    facebook: "https://www.facebook.com/share/1EPXu2GzLs/?mibextid=wwXIfr",
    tiktok: null,
    yelp: null,
  },

  discount: {
    label: "$100 Gift Card for Every Referral",
    short: "$100 Referral Reward",
    description:
      "Refer a friend and receive a $100 gift card once their project is complete. Active-duty military and retired personnel always receive 10% off.",
    military: "10% Military & Veteran Discount",
  },

  // LeadConnector / Reputation Hub widgets for the 4 Seasons Painting sub-account.
  widgets: {
    chatWidgetId: "6a717bfebb77c2fae876f1f5",
    chatLoaderSrc: "https://widgets.leadconnectorhq.com/loader.js",
    chatResourcesUrl: "https://widgets.leadconnectorhq.com/chat-widget/loader.js",

    reviewScriptSrc: "https://reputationhub.site/reputation/assets/review-widget.js",
    reviewIframeSrc:
      "https://reputationhub.site/reputation/widgets/review_widget/GW31Wfabg5Ie42VC0S5f?widgetId=6a72956b796dbac1b2a88f51",

    formIframeSrc: "https://link.systemic-digital.net/widget/form/jAQJb37iKlCIKRmVk76d",
    formScriptSrc: "https://link.systemic-digital.net/js/form_embed.js",
    formId: "jAQJb37iKlCIKRmVk76d",
    formName: "Website Form",
    /** Native form height reported by the embed code. */
    formHeight: "717",
  },

  serviceAreas: [
    "Phoenix, AZ",
    "Scottsdale, AZ",
    "Gilbert, AZ",
    "Chandler, AZ",
    "Mesa, AZ",
    "Apache Junction, AZ",
    "San Tan Valley, AZ",
    "Florence, AZ",
    "Casa Grande, AZ",
    "Coolidge, AZ",
    "Surprise, AZ",
    "Sun City, AZ",
    "Goodyear, AZ",
    "Avondale, AZ",
    "Peoria, AZ",
  ],
} as const;

export type SiteConfig = typeof siteConfig;
